import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy /account/user/health-passport = redirect to /medical-vault.
 * Health passport is the default tab inside the unified medical vault.
 */
export const Route = createFileRoute("/_authenticated/account/user/health-passport")({
  beforeLoad: () => {
    throw redirect({
      to: "/account/user/medical-vault",
      search: { tab: "passport", subtab: "active" } as never,
    });
  },
});
